import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { SuccessIcon } from '../../Assets/svgs'

const statusUI = [
    {
        id: 1,
        status: "info",
        bgcolor: "#FFBC1F1A",
        borderColor: "#E89806",
        color: "#805404",
        msg: "Your business is undergoing an approval process, Kindly check back periodically to know if it has been approved or rejected."
    },
    {
        id: 2,
        status: "success",
        bgcolor: "#40DD7F1A",
        borderColor: "#1AB759",
        color: "#1AB759",
        msg: "Yay! your business has been approved",
        img: <SuccessIcon />
    },
    {
        id: 2,
        status: "failed",
        bgcolor: "#FF626226",
        borderColor: "#E93C3C",
        color: "#E93C3C",
        msg: <p>Your business has sadly been rejected.<br /><br />Reason: Not enough info provided.</p>
    }
]


const NotificationUI = ({ status }) => {
    return (

        <>
            {statusUI?.map(item => (
                item.status === status ?
                    <Stack alignItems={item?.img && "center"} gap={item?.img && 3} bgcolor={item?.bgcolor} border={`1px solid ${item?.borderColor}`} color={item?.color} p={4} borderRadius={"8px"} mt={4}>
                        {item?.img}
                        <Typography variant='body1' fontWeight={600}>{item?.msg}</Typography>
                    </Stack> : ""
            ))}


        </>
    )
}

export default NotificationUI